// flag to prevent quick multi-click glitches

import MyConfig from "@/../me.config.js";
require("jquery");
let current_fs, next_fs, previous_fs; // fieldsets
let left, opacity, scale; // fieldset properties which we will animate
let animating;

export function nextStep(curr, next) {
  $("html, body").animate({ scrollTop: 0 }, 600, "easeOutQuad");
  if (animating) return false;
  animating = true;

  // if (this.$vnode.tag.indexOf('QuestionStep2_Q7') > -1) {
  //   let info = JSON.parse(sessionStorage.getItem('Information'))
  //   let health = JSON.parse(sessionStorage.getItem('MoneyHealth5'))
  //   let baseAge = info.gender == 'f' ? 80 : 73
  //   if (parseInt(info.age) > parseInt(health.retire) || parseInt(health.retire) > baseAge) {
  //     $('#money-health-save_retire').hide()
  //   }else{
  //     $('#money-health-save_retire').show()
  //   }
  // }

  if (
    this.$vnode.tag.indexOf("QuestionStep2_Q3") > -1 ||
    this.$vnode.tag.indexOf("QuestionStep2_Q6") > -1 ||
    this.$vnode.tag.indexOf("QuestionStep2_Q8") > -1 ||
    this.$vnode.tag.indexOf("QuestionStep2_Q9") > -1
  ) {
    if (
      this.$vnode.tag.indexOf("QuestionStep2_Q3") > -1 &&
      this.money_health == "-1"
    ) {
      $("#money-health-stanby").hide();
    } else if (
      this.$vnode.tag.indexOf("QuestionStep2_Q3") > -1 &&
      this.money_health != "-1"
    ) {
      $("#money-health-stanby").show();
    }

    if (
      this.$vnode.tag.indexOf("QuestionStep2_Q6") > -1 &&
      this.vat_refund == "full"
    ) {
      $("#money-health-changevat").hide();
    } else if (
      this.$vnode.tag.indexOf("QuestionStep2_Q6") > -1 &&
      this.vat_refund != "full"
    ) {
      $("#money-health-changevat").show();
    }

    // if (this.$vnode.tag.indexOf('QuestionStep2_Q8') > -1 && this.money_retire == '-1') {
    //   $('#money-health-save_retire').hide()
    // }else if( this.$vnode.tag.indexOf('QuestionStep2_Q8') > -1 && this.money_retire != '-1' ){
    //   $('#money-health-save_retire').show()
    // }

    if (this.$vnode.tag.indexOf("QuestionStep2_Q9") > -1) {
      let a = JSON.parse(sessionStorage.getItem("ChildParent"));
      let found = 0;
      for (let i = 0; i < a.child; i++) {
        if (a.child_age[i] >= 1 && a.child_age[i] < 22) {
          found = 1;
        }
      }
      if (found == 0) {
        this.$nextTick(() => {
          $("#money-health-child").hide();
          if ($("*[id^=money-health-]:visible").length == 1) {
            sessionStorage.setItem("skipQuize10", 1);
            window.location.href = MyConfig.HealthPath;
          }
        });
      } else {
        $("#money-health-child").show();
      }
    }

    if (
      this.$vnode.tag.indexOf("QuestionStep2_Q9") > -1 &&
      this.money_to_child == "-1"
    ) {
      $("#money-health-legacy").hide();
    } else if (
      this.$vnode.tag.indexOf("QuestionStep2_Q9") > -1 &&
      this.money_to_child != "-1"
    ) {
      $("#money-health-legacy").show();
    }
  }

  if (this.$vnode.tag.indexOf("QuestionStep2_Q9")) {
    let info = JSON.parse(sessionStorage.getItem("Information"));
    let retireAge = JSON.parse(sessionStorage.getItem("MoneyHealth5"));
    let money = JSON.parse(sessionStorage.getItem("MoneyHealth6"));
    let baseAge = info.gender == "f" ? 80 : 73;

    if (info && retireAge && money) {
      if (
        parseInt(retireAge.retire) < baseAge &&
        parseInt(retireAge.retire) > parseInt(info.age) &&
        money.money_retire != "-1"
      ) {
        $("#money-health-save_retire").show();
      } else {
        $("#money-health-save_retire").hide();
      }
    }
  }

  current_fs = $(".tab." + curr);
  next_fs = $(".tab." + next);
  let tmp = this.$vnode.tag.split("QuestionStep");
  let _step = tmp[1].split("_Q");

  sessionStorage.setItem("step" + _step[0], _step[1]);
  this.$parent.currentStep = _step[1];

  //   $('#progressbar li').eq($('fieldset').index(next_fs)).addClass('active')

  next_fs.fadeIn(800);
  next_fs.css("height", "auto");
  current_fs.animate(
    {
      opacity: 0
    },
    {
      step: function(now, mx) {
        scale = 1 - (1 - now) * 0.2;
        left = now * 50 + "%";
        current_fs.css({
          position: "absolute",
          height: "auto"
        });

        next_fs.css({
          opacity: opacity,
          top: "0"
        });
        setTimeout(function() {
          next_fs.css({
            height: "auto"
          });
        }, 200);
      },
      duration: 800,
      complete: function() {
        current_fs.hide();
        animating = false;
        next_fs.next().css("height", current_fs.outerHeight() + "px");
      },
      easing: "easeOutExpo"
    }
  );
}

export function prevStep(curr, prev) {
  $("html, body").animate({ scrollTop: 0 }, 600, "easeOutQuad");
  if (animating) return false;
  animating = true;
  current_fs = $(".tab." + curr);
  previous_fs = $(".tab." + prev);
  //   $('#progressbar li').eq($('fieldset').index(current_fs)).removeClass('active')
  previous_fs.fadeIn(800);
  current_fs.animate(
    {
      opacity: 0
    },
    {
      step: function(now, mx) {
        scale = 0.8 + (1 - now) * 0.2;
        left = (1 - now) * 50 + "%";
        opacity = 1 - now;
        current_fs.css({
          height: "auto"
        });
        previous_fs.css({
          transform: "scale(" + scale + ")",
          opacity: opacity,
          top: "0"
        });
      },
      duration: 800,
      complete: function() {
        current_fs.hide();
        animating = false;
      },
      easing: "easeOutExpo"
    }
  );
}
